import { ECarriersList, ICarrierIntegrationInfo } from './Carrier';
import type { IClaimReturnDetail } from './Claim';

export interface IState {
	errorCode?: number;
	errorMessage?: string;
	claims: IClaims[] | null;
	change: boolean;
	pages: number;
	page: number;
	search: boolean;
}

export enum CLAIM_STATUSES {
	PENDING_DOCUMENTATION = 1,
	SUBMITTED = 3,
	APPROVED = 4,
	PAID = 5,
	ABORTED = 6,
	REJECTED_PAST_DOS = 7,
	REJECTED = 8,
	SENT_FOR_PAYMENT = 9,
	TO_VOID = 10,
	SENT_FOR_VOID = 11,
	VOIDED = 12,
	PAID_VOIDED = 13,
	PAID_VOIDED_REKEY = 14,
	CANCELED = 15,
	DRAFT_IN_PROGRESS = 16,
	SUBMIT_IN_PROGRESS = 17,
	PENDING = 18,
	CANCEL_IN_PROGRESS = 19,
}

export const NOT_SUBMITTED_STATUSES: claimStatusIds[] = [
	CLAIM_STATUSES.PENDING_DOCUMENTATION,
	CLAIM_STATUSES.DRAFT_IN_PROGRESS,
	CLAIM_STATUSES.SUBMIT_IN_PROGRESS,
];

export type claimStatusIds =
	| 1 // Pending documnetation
	| 3 // Submitted
	| 4 // Approved
	| 5 // Paid
	| 6 // Aborted
	| 7 // Rejected Past Dos
	| 8 // Rejected
	| 9 // Sent for payment
	| 10 // To void
	| 11 // Sent for void
	| 12 // Voided
	| 13 // Paid Voided
	| 14 // Paid Voided Rekey
	| 15 // Canceled
	| 16 // draft_in_progress
	| 17 // submit_in_progress
	| 18 // Pending
	| 19; // cancel_in_progress

export interface IClaimCarrierIntegrationInfo {
	carrierClaimId: string | null;
	customFaschimExtraInfo: string | null;
	memberFiscalCode: string | null;
}
export interface IClaimStatus {
	id: claimStatusIds;
	name: string;
	label: string;
	groupCode: string;
	groupLabel: string;
	internalNote?: string;
}

export interface IClaims {
	claimUUID: string;
	externalClaimId: string;
	memberFullName: string;
	beneficiary: string;
	memberFirstName: string;
	memberLastName: string;
	groupName: string;
	claimDate: string;
	memberProviderLocation: string;
	planPayAmount: number;
	memberPayAmount: number;
	paidWith: string;
	status: {
		id: claimStatusIds;
		name: string;
		label: string;
		groupCode: string;
		groupLabel: string;
	};
	carrierIntegrationFlow: ECarriersList;
	claimCarrierIntegrationInfo: ICarrierIntegrationInfo;
	clientName: string;
	claimInNetwork: boolean;
	returnDetail?: IClaimReturnDetail;
	hasComplaint?: boolean;
	hasFraud?: boolean;
	networkCode: string;
}

export interface IClaimState {
	number: number;
	sortingFields: string;
	sortingDirections: 'ASC' | 'DESC';
}

export interface IClaimDownload {
	id?: number | 0;
	uuid: string | undefined;
	type: string;
}

export interface INetworkStatus {
	id: number;
	name: string;
	label: string;
}

export interface IReturnStatus {
	code: string;
	label: string;
}

export interface IClaimStatusUpdatePayload {
	claimUuids: (string | number)[];
	statusId: number;
	reasonCode?: string;
	note?: string;
	denialArticle?: string;
	denialNumArticle?: string;
}

export interface IClaimNetwork {
	networkCode: string;
	networkCodeSlug: string;
	name: string;
	description: string;
}

export const CLAIM_NETWORK_STATUSES = [
	{
		name: 'INN',
		label: 'network_status.INN',
		id: 0,
	},
	{
		name: 'OON',
		label: 'network_status.OON',
		id: 1,
	},
];
